const prefix = "COMMENTS::";

export const SET_LOADING = `${prefix}SET_LOADING`;
export const SET_LIST = `${prefix}SET_LIST`;
export const ADD = `${prefix}ADD`;
export const SET_IS_COMMENTING = `${prefix}SET_IS_COMMENTING`;
export const DELETE = `${prefix}DELETE`;